import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { getRoleLabel, getBlockModeLabel } from '../../helpers/user';
import {
  Card,
  Button,
  Header,
  Label,
  Loader,
  Grid,
  Input,
  Icon,
  Confirm,
} from 'semantic-ui-react';
import { userActions } from '../../actions/user.actions';
import PropTypes from 'prop-types';
import { history } from '../../helpers';
import { userConstants } from '../../constants/user.constants';
import _ from 'lodash';
import { PaginationContainer } from '../../components/PaginationContainer';
import moment from 'moment';
import momentDurationFormatSetup from "moment-duration-format";

class GroupIndexScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: null,
      users: null,
      confirmOpen: false,
      confirmAction: null,
      confirmUser: null,
      confirmMessage: null
    };
  }

  static get propTypes() {
    return {
      users: PropTypes.any,
      confirmOpen: PropTypes.bool,
      confirmAction: PropTypes.string,
      confirmMessage: PropTypes.string,
      confirmUser: PropTypes.any,
      loading: PropTypes.bool,
    };
  }

  componentDidMount() {
    this.handleSearchDebounced = _.debounce(function() {
      this.fetchGroups();
    }, 500);

    this.fetchGroups();
  }

  fetchGroups() {
    const { dispatch } = this.props;
    const { page, search } = this.state;
    dispatch(userActions.fetchGroups({ page, search }));
  }

  handleSearch(search) {
    this.setState({ search, page: 1 });
    this.handleSearchDebounced();
  }

  handlePageChange(activePage) {
    this.setState({ page: activePage }, () => this.fetchGroups());
  }

  showConfirm(group, action) {
    const msg =  `Tem certeza que deseja remover o grupo ${group.Name}?`;
    this.setState({
      confirmOpen: true,
      confirmAction: action,
      confirmGroup: group,
      confirmMessage: msg
    });
  }

  closeConfirm() {
    this.setState({ confirmOpen: false});
  }

  executeConfirm() {
    const { dispatch } = this.props;
    const { confirmGroup, confirmAction } = this.state;
    if (confirmAction == 'remove') {
      dispatch(userActions.removeGroup(confirmGroup.Id)).then(() => this.fetchGroups());
    }
    setTimeout(() => this.fetchGroups(), 1000);
    this.setState({
      confirmOpen: false,
      confirmAction: null,
      confirmGroup: null,
      confirmMessage: null
    });
  }

  goToCreate() {
    history.push('/group/create');
  }

  render() {
    const { loading, groups, me } = this.props;

    // Check Permission    
    if (me && me.Role != userConstants.ROLE_ADMIN) {
      window.location.href = "/";
      return;
    }
    
    return (
      <Fragment>
        <Loader active={loading}>Carregando...</Loader>
        <Confirm open={this.state.confirmOpen} content={this.state.confirmMessage} onCancel={() => this.closeConfirm()} onConfirm={() => this.executeConfirm()} />
        <Header>
          <h1>Grupos</h1>
        </Header>

        <Grid stackable columns='2'>
          <Grid.Row>
            <Grid.Column textAlign='left' width={12}>
              <Input icon='search' fluid onChange={(e, data) => this.handleSearch(data.value)} placeholder='Procurar...' loading={loading} />
            </Grid.Column>

            <Grid.Column textAlign='right' width={4}>
              <Button color='primary' fluid onClick={this.goToCreate}>Novo Grupo</Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Card.Group>
          { (!groups || (groups.Results && groups.TotalNumberOfRecords == 0)) &&
          <Card header='Nenhum Grupo' fluid />
          }

          { groups && groups.Results && groups.Results.map((group) => {
            return <Card key={group.Id} fluid>
              <Card.Content>
                <Card.Header>
                  {group.Name}
                  {group.ExternalId &&
                  <Label style={{float: "right", marginRight: '4px'}} color='blue'>
                    {group.ExternalId}
                  </Label>}
                </Card.Header>
                <Card.Description>
                  <p><strong>Membros:</strong> {group.AzureAdSync ? 'Sincronizado com Azure AD' : (group.AdSync ? 'Sincronizado com AD' : group.Users.filter((item) => item.Type === 1).map((item) => item.User.Name).join(', '))}</p>
                  <p><strong>Aprovadores:</strong> {group.Users.filter((item) => item.Type === 2).map((item) => item.User.Name).join(', ')}</p>
                  <p><strong>Labels:</strong> {group.Labels.map((item) => item.Label).join(', ')}</p>
                </Card.Description>
              </Card.Content>
              <Card.Content extra>
                <Button size='mini' secondary icon onClick={() => history.push(`/group/update/${group.Id}`) }>
                  <Icon name='edit' />
                  Alterar
                </Button>

                <Button size='mini' color='red' icon onClick={() => this.showConfirm(group, 'remove') }>
                  <Icon name='cancel' />
                  Excluir
                </Button>
              </Card.Content>
            </Card>
          }) }
        </Card.Group>

        <PaginationContainer registers={groups} onPageChange={(e, { activePage }) => this.handlePageChange(activePage) } />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { users } = state;
  
  return {  
    groups: users.groups,
    loading: users.loading,
    me: users.me || null,
  };
}

const connectedGroupIndexScreen = connect(mapStateToProps)(GroupIndexScreen);
export { connectedGroupIndexScreen as GroupIndexScreen };
